export default __webpack_public_path__ + "static/media/Shot_22.0000.7cf471c6.png";